import DOMPurify from "dompurify";

/** Central sanitizer for any HTML we render via dangerouslySetInnerHTML or contentEditable
 *  seeding. Uses DOMPurify with default profile plus a few safe tags we use in reports/contracts. */
const CONFIG = {
  ADD_TAGS: ["style"], // report/contract HTML includes inline <style>
  ADD_ATTR: ["target", "rel"],
};

export function sanitizeHtml(html) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), CONFIG);
}
